module.exports = __webpack_public_path__ + "img/porto-2.e90cccd2.png";